export const __CONFIG_KEY__ = '__config__'
export const __ROOT_NODE__ = 'root'
export const __I18N_KEY__ = '__i18n__'

export const FALLBACK_DEFAULT_VERTICALS_WITH_ADDITIONAL_OPTIONS = [
  'cargo',
  'express',
]
export const FALLBACK_DEFAULT_BDUI_VERTICALS = []
export const FALLBACK_PARCEL_SIZES = [
  {
    id: 'extraSmall',
    width: 2,
    height: 20,
    length: 26,
    weight: 1,
  },
  {
    id: 'small',
    width: 15,
    height: 10,
    length: 25,
    weight: 2,
  },
  {
    id: 'medium',
    width: 25,
    height: 15,
    length: 35,
    weight: 5,
  },
  {
    id: 'large',
    width: 30,
    height: 20,
    length: 45,
    weight: 12,
  },
  {
    id: 'extraLarge',
    width: 45,
    height: 40,
    length: 60,
    weight: 20,
  },
  {
    id: 'extraExtraLarge',
    width: 60,
    height: 60,
    length: 80,
    weight: 20,
  },
]
